module.exports = __webpack_public_path__ + "img/center back length from waist seam to hem.46e441a6.png";